export var OutputStatus;

(function (OutputStatus) {
  OutputStatus["output_some"] = "output_some";
  OutputStatus["output_all"] = "output_all";
  OutputStatus["output_none"] = "output_none";
})(OutputStatus || (OutputStatus = {}));

export var ProductsCategories;

(function (ProductsCategories) {
  ProductsCategories["neutrional_supplement"] = "neutrional_supplement";
  ProductsCategories["food_supplement"] = "food_supplement";
  ProductsCategories["drug"] = "drug";
  ProductsCategories["medical_device"] = "medical_device";
  ProductsCategories["medical_care_outpatient_service"] = "medical_care_outpatient_service";
  ProductsCategories["medical_care_treatment"] = "medical_care_treatment";
  ProductsCategories["medical_care_examination"] = "medical_care_examination";
  ProductsCategories["medical_care_wellness_program"] = "medical_care_wellness_program";
  ProductsCategories["medical_care_therapy"] = "medical_care_therapy";
})(ProductsCategories || (ProductsCategories = {}));

export var MedicineCategory;

(function (MedicineCategory) {
  MedicineCategory["neutrional_supplement"] = "neutrional_supplement";
  MedicineCategory["food_supplement"] = "food_supplement";
  MedicineCategory["drug"] = "drug";
  MedicineCategory["medical_device"] = "medical_device";
})(MedicineCategory || (MedicineCategory = {}));